const CHECK_EMAIL = 'dofe-fo/asyncValidations/CHECK_EMAIL'
const CHECK_EMAIL_SUCCESS = 'dofe-fo/asyncValidations/CHECK_EMAIL_SUCCESS'
const CHECK_EMAIL_FAIL = 'dofe-fo/asyncValidations/CHECK_EMAIL_FAIL'

const CHECK_PASSWORD = 'dofe-fo/asyncValidations/CHECK_PASSWORD'
const CHECK_PASSWORD_SUCCESS = 'dofe-fo/asyncValidations/CHECK_PASSWORD_SUCCESS'
const CHECK_PASSWORD_FAIL = 'dofe-fo/asyncValidations/CHECK_PASSWORD_FAIL'

const CHECK_ASSESSOR_EMAIL_AVAILABILITY = 'dofe-fo/asyncValidations/CHECK_ASSESSOR_EMAIL_AVAILABILITY'
const CHECK_ASSESSOR_EMAIL_AVAILABILITY_SUCCESS = 'dofe-fo/asyncValidations/CHECK_ASSESSOR_EMAIL_AVAILABILITY_SUCCESS'
const CHECK_ASSESSOR_EMAIL_AVAILABILITY_FAIL = 'dofe-fo/asyncValidations/CHECK_ASSESSOR_EMAIL_AVAILABILITY_FAIL'

const initialState = {
  loaded: false,
  data: null
}

export default function asyncValidations(state = initialState, action = {}) {
  switch (action.type) {
    case CHECK_EMAIL:
      return {
        ...state,
        loading: true
      }

    case CHECK_EMAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null
      }

    case CHECK_EMAIL_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case CHECK_PASSWORD:
      return {
        ...state,
        loading: true
      }

    case CHECK_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null
      }

    case CHECK_PASSWORD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case CHECK_ASSESSOR_EMAIL_AVAILABILITY:
      return {
        ...state,
        loading: true
      }

    case CHECK_ASSESSOR_EMAIL_AVAILABILITY_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null
      }

    case CHECK_ASSESSOR_EMAIL_AVAILABILITY_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    default:
      return state
  }
}

export function checkPasswordEmail(personId, password) {
  return {
    types: [CHECK_PASSWORD, CHECK_PASSWORD_SUCCESS, CHECK_PASSWORD_FAIL],
    promise: client =>
      client.post(`api/persons/${personId}/is-new-password-valid`, {
        removeToken: true,
        data: {
          newPassword: password
        }
      })
  }
}

export function checkEmail({ email, checkAlternativeEmails = false }) {
  return {
    types: [CHECK_EMAIL, CHECK_EMAIL_SUCCESS, CHECK_EMAIL_FAIL],
    promise: client =>
      client.post('api/registration/email-availability', {
        removeToken: true,
        data: {
          value: email,
          checkAlternativeEmails,
        }
      })
  }
}

export function checkAssessorEmailAvailability(email, orgId, activityCategoryId) {
  return {
    types: [CHECK_ASSESSOR_EMAIL_AVAILABILITY, CHECK_ASSESSOR_EMAIL_AVAILABILITY_SUCCESS, CHECK_ASSESSOR_EMAIL_AVAILABILITY_FAIL],
    promise: client =>
      client.post('api/assessors/email-availability', {
        removeToken: true,
        data: { email, orgId, activityCategoryId }
      })
  }
}
